module.exports = __webpack_public_path__ + "65f91b538cf6b463f1eef4cb4fead60c.jpg";